import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import Exercise from "../../models/exercise.model";

@Component({
  selector: "ngx-dialog-link-exercise",
  templateUrl: "dialog-link-exercise.component.html",
  styleUrls: ["dialog-link-exercise.component.scss"],
})
export class DialogLinkExerciseComponent implements OnInit {
  @Input() header: string;
  @Input() description?: string;
  @Input() linkExerciseId: string;
  @Input() exercises?: Exercise[];
  submitted = false;
  strSearch = "";
  displays?: Exercise[];

  constructor(
    protected ref: NbDialogRef<DialogLinkExerciseComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.displays = [...this.exercises];
  }

  cancel() {
    this.ref.close();
  }

  selected(item) {
    this.submitted = true;
    const value = {
      linkExerciseId: item.id,
    };
    this.ref.close(value);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      linkExerciseId: "",
    };
    this.ref.close(value);
  }

  onSearch(): void {
    this.displays = this.exercises.filter(
      function (item) {
        return item.title.toLowerCase().includes(this.title);
      },
      { title: this.strSearch }
    );
  }
}
